import { builderAdapter } from 'lineupjs';
import * as React from 'react';
var ChildWrapper = /** @class */ (function () {
    function ChildWrapper(props, type) {
        this.props = props;
        this.type = type;
    }
    ChildWrapper.prototype.create = function () {
        return new this.type(this.props, null);
    };
    return ChildWrapper;
}());
export { ChildWrapper };
export function filterChildrenProps(children, clazz) {
    return React.Children.toArray(children)
        .filter(function (d) { return React.isValidElement(d) && builderAdapter.isTypeInstance(d.type, clazz); })
        .map(function (d) {
        return new ChildWrapper(d.props, d.type);
    });
}
//# sourceMappingURL=utils.js.map